export enum SumamoruPlan {
  OG_Default = 'OG_Default',
  OG_WLock = 'OG_WLock',
  OG_Viewn = 'OG_Viewn'
}
